import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type FilterTagStyles = {
  filter: CSSProperties;
  filter__close: CSSProperties;
};

const styles: FilterTagStyles = {
  filter: {
    margin: 0,
    marginTop: '15px',
    marginRight: '4px',
    padding: '8px 16px',
    borderRadius: '24px',
    color: AppColors.VA.NEUTRALS._90_,
    backgroundColor: AppColors.VA.NEUTRALS._30_
  },
  filter__close: {
    color: AppColors.VA.NEUTRALS._90_,
    cursor: 'pointer'
  }
};

export default styles;
